
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendService } from 'src/app/shared/services/backend.services';


@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
    public productsList: any;
    public trialExpiryDate: any = null;
    public emitMarketplaceAPISource = new Subject<string>();
    public emitMarketplaceAPISource$: Observable<string> = this.emitMarketplaceAPISource.asObservable();
  
    constructor(private backendService: BackendService) { }

    /**
     * @author Upender
     * fetches user details from json file
     * @returns { Observable<any> }
     */
    public getLandingPageUserDetails(): Observable<any> {
        const url = '/ava/api/landing/allProducts';

        return this.backendService.get(url).pipe(
            map((response) => response)
        );
    }

    /**
     *
     * this method will return the product detail list
     * @return {*}  {Observable<any>}
     * @memberof LandingPageService
     */
    public getProductDetailsList(): Observable<any> {
        const url = '/ava/api/landing/marketplace';
    
        return this.backendService.get(url).pipe(
            map((response) => response)
        );
    }

    /**
     * this will set all the products list
     * @params {productsList} any
     * @returns void
     * @param {*} productsList
     * @memberof LandingPageService
     */
    public setProductsList(productsList: any): void {
        this.productsList = productsList;
    }

    /**
     * this will bribng all the products lists
     * @return {any}
     * @memberof LandingPageService
     */
    public getProductsList(): any {
       return this.productsList;
    }

    /**
     * this wil filter the records based on the tab selected value
     * @param {tabValue} string
     * @returns {any}
     * @memberof LandingPageService
     */
    public getSelectedTabProdcutsList(tabvalue: string): any {
        const filteredProductList: any = [];

        this.getProductsList().forEach((product: any) => {
            if (product.categoryCode === tabvalue) {
                filteredProductList.push(product);
            }
        });

        return filteredProductList;
    }

    public getStartTrailDetails(productId: any) {
        const url = '/ava/api/trial/status';
        const request = {
            'authenticated': true,
            'productId': productId
        };

        return this.backendService.post(url, request).pipe(
            map((response) => response)
        );
    }

    public emitMarketplaceAPI() {
        this.emitMarketplaceAPISource.next();
    }
}
